module.exports = __webpack_public_path__ + "static/media/logo.b536b6d2.png";